import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ListItemIconDirective } from './list-item-icon/list-item-icon.directive';
import { ListItemComponent } from './list-item/list-item.component';
import { ListComponent } from './list.component';

@NgModule({
  imports: [CommonModule],
  declarations: [ListComponent, ListItemComponent, ListItemIconDirective],
  exports: [ListComponent, ListItemComponent, ListItemIconDirective],
})
export class ListModule {}
